import { render, staticRenderFns } from "./attencelog.vue?vue&type=template&id=0cab8965&"
import script from "./attencelog.vue?vue&type=script&lang=ts&"
export * from "./attencelog.vue?vue&type=script&lang=ts&"
import style0 from "./attencelog.vue?vue&type=style&index=0&id=0cab8965&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports